import { ComplaintFlowProps } from 'features/complaint/views/flow/types'
import { useFormContext } from 'react-hook-form'
import { Button, Form, Heading } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import { ComplaintFlowInputs } from 'features/complaint/views/flow/types'
import { Email, FirstName, LastName, Phone } from 'components/inputs'
import { setPostHogPersonProperties } from 'utils/tracking'
import React from 'react'

const Contact = ({ setCurrentStep }: ComplaintFlowProps) => {
  // i18n
  const { t } = useTranslation('complaint', { keyPrefix: 'flow.steps.contact' })
  const { t: tX } = useTranslation(['common', 'validation'])

  // React Hook Form
  const hookForm = useFormContext<Pick<ComplaintFlowInputs, 'contact'>>()
  const { handleSubmit } = hookForm

  /**
   * Submit handler for the contact step of the complaint flow.
   */
  const submit = (inputs: Pick<ComplaintFlowInputs, 'contact'>) => {
    if (inputs.contact.email) {
      setPostHogPersonProperties({ email: inputs.contact.email })
    }

    setCurrentStep('complaint')
  }

  return (
    <section>
      <header>
        <Heading as="h2">{t('title')}</Heading>
        <p>{t('description')}</p>
      </header>

      <Form onSubmit={handleSubmit(submit)}>
        <FirstName parentDotPath="contact" />
        <LastName parentDotPath="contact" />
        <Email parentDotPath="contact" grid="full" label={t('email.label')} description={t('email.description')} />
        <Phone parentDotPath="contact" grid="full" label={t('phone.label')} required={false} description={t('phone.description')} />

        <Form.Footer className="flex-row mt-400">
          <Button type="submit" trailingIcon="arrowRight" className="ml-auto">
            {tX('next')}
          </Button>
        </Form.Footer>
      </Form>
    </section>
  )
}

export default Contact
